import * as React from "react";
import type { SVGProps } from "react";
const SvgVisa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#0e4595"
      d="M20 6H4c-1.105 0-2 .908-2 2.028v8.944C2 18.092 2.895 19 4 19h16c1.105 0 2-.908 2-2.028V8.028C22 6.908 21.105 6 20 6"
    />
    <path
      fill="#fff"
      d="m9.518 15.032.855-5.02h1.369l-.857 5.02zm6.31-4.911a3.5 3.5 0 0 0-1.226-.211c-1.352 0-2.304.68-2.312 1.656-.008.722.68 1.124 1.199 1.364.532.246.711.403.709.623-.004.336-.425.49-.819.49-.547 0-.838-.076-1.288-.263l-.176-.08-.192 1.124c.32.14.91.261 1.524.267 1.438 0 2.372-.673 2.383-1.715.005-.57-.36-1.005-1.15-1.364-.477-.232-.77-.387-.767-.622 0-.208.248-.431.783-.431.448-.007.772.09 1.024.192l.123.058zm3.521-.109h-1.057c-.328 0-.573.09-.716.417l-2.032 4.6h1.436s.235-.619.288-.755l1.753.003c.04.175.166.752.166.752h1.27zm-1.677 3.242.545-1.403c-.008.013.112-.29.181-.48l.093.433.317 1.45zm-9.316-3.242-1.34 3.424-.142-.696c-.25-.802-1.026-1.67-1.895-2.106l1.225 4.39 1.448-.001 2.154-5.01z"
    />
    <path
      fill="#f2ae14"
      d="M5.767 10.102H3.561l-.017.105c1.716.415 2.852 1.42 3.323 2.626l-.48-2.307c-.082-.318-.323-.413-.62-.424"
    />
  </svg>
);
export default SvgVisa;
